import React from 'react';

import PropTypes from 'prop-types';

import Icon from '@/orderDetails/ActivityLog/Icon';

const OrderHistoric = ({ intl, historic }) => (
  <div className="w-full bg-white">
    {historic.length > 0 ? (
      <div className="flex justify-between items-center flex-wrap my-5 text-[#858585]">
        <div className="flex justify-between w-full flex-none mb-4 leading-5 text-[12px] font-bold">
          <div style={{ paddingLeft: '11px' }}>Ação</div>

          <div style={{ paddingRight: '10px' }}>Data e Hora</div>
        </div>
        {historic.map((record, index) => (
          <React.Fragment key={record.id}>
            <div
              className={`relative flex justify-between w-full flex-none text-[10px] before:content-[''] before:absolute before:top-[1px] before:left-[10px] before:h-[calc(100%-1px)] before:border-l before:border-dotted before:border-[#858585] before:z-[1] ${index === historic.length - 1 && !record.notes ? 'before:border-none' : ''}`}
              style={{ paddingBottom: !record.notes ? '4em' : '0.5em' }}
            >
              <div style={{ width: '50%' }} className="flex items-center">
                <div className="relative flex justify-center items-center w-[21px] h-[21px] border-2 border-white rounded-full leading-none bg-white text-white z-[2]">
                  <Icon action={record.type} />
                </div>
                <div className="ml-2">{intl.formatMessage({ id: record.type })}</div>
              </div>

              <div style={{ paddingRight: '10px' }} title={record.humanDate}>
                {record.date}
              </div>
            </div>
            {record.notes && (
              <div className={`relative flex justify-between w-full pb-16 flex-none text-[10px] before:content-[''] before:absolute before:top-[1px] before:left-[10px] before:h-[calc(100%-1px)] before:border-l before:border-dotted before:border-[#858585] before:z-[1] ${index === historic.length - 1 ? 'before:border-none' : ''}`}>
                <div className="flex items-center">
                  <div className="mt-[-10px] ml-[10px] mr-3 bg-[#858585] h-3 w-[1px] relative after:content-[''] after:bg-[#858585] after:h-[1px] after:left-0 after:absolute after:top-3 after:w-[15px]"></div>
                  <div className="ml-2">{record.notes}</div>
                </div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    ) : (
      <div className="flex justify-center w-full">
        <span>Sem histórico</span>
      </div>
    )}
  </div>
);

OrderHistoric.propTypes = {
  intl: PropTypes.object.isRequired,
  historic: PropTypes.array.isRequired,
};

export default OrderHistoric;
